var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNamecard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 63,
    viewBox: "0 0 340 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3967_65956)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 63,
    rx: 6,
    fill: "#20696F"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3967_65956)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2057 -6.24023H12.6016V6.36393H25.2057V-6.24023Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.0815,
    cy: -6.11422,
    r: 12.3521,
    transform: "rotate(90 25.0815 -6.11422)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.726,
    cy: 6.23783,
    r: 12.3521,
    transform: "rotate(90 12.726 6.23783)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4167 6.36499H37.8125V18.9692H50.4167V6.36499Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.2924,
    cy: 6.491,
    r: 12.3521,
    transform: "rotate(90 50.2924 6.491)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.937,
    cy: 18.8431,
    r: 12.3521,
    transform: "rotate(90 37.937 18.8431)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.042 56.7812H113.438V69.3854H126.042V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.917,
    cy: 56.9073,
    r: 12.3521,
    transform: "rotate(90 125.917 56.9073)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.562,
    cy: 69.2593,
    r: 12.3521,
    transform: "rotate(90 113.562 69.2593)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.0182 -6.24023H50.4141V6.36393H63.0182V-6.24023Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5396,
    cy: -6.11422,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.8911,
    cy: 6.23783,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.44 18.9688H100.836V31.5729H113.44V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.961,
    cy: 19.0948,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.313,
    cy: 31.4468,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.643 6.36523H126.039V18.9694H138.643V6.36523Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.165,
    cy: 6.49125,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.516,
    cy: 18.8433,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.2292 6.36499H75.625V18.9692H88.2292V6.36499Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.7505,
    cy: 6.491,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.1021,
    cy: 18.8431,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6042 -6.23999H0V6.36418H12.6042V-6.23999Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.30104,
    cy: -6.23997,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.643 56.7812H126.039V69.3854H138.643V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.34,
    cy: 56.7813,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8151 -6.24023H25.2109V6.36393H37.8151V-6.24023Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.2112,
    cy: 0.0617847,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4167 -6.23999H37.8125V6.36418H50.4167V-6.23999Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.1135,
    cy: 0.0620289,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.44 6.36523H100.836V18.9694H113.44V6.36523Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.137,
    cy: 12.6673,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.6276 6.36523H63.0234V18.9694H75.6276V6.36523Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.3245,
    cy: 12.6673,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.0182 6.36523H50.4141V18.9694H63.0182V6.36523Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5396,
    cy: 6.49125,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.6276 18.9688H63.0234V31.5729H75.6276V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.5005,
    cy: 19.0948,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.5003,
    cy: 19.0947,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.464 31.5723H163.859V44.1764H176.464V31.5723Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.336,
    cy: 31.6983,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.336,
    cy: 31.6983,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.878 31.5723H214.273V44.1764H226.878V31.5723Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.751,
    cy: 31.6983,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.75,
    cy: 31.6983,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.268 44.1758H201.664V56.7799H214.268V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.141,
    cy: 44.3018,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.141,
    cy: 44.3018,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.089 44.1758H239.484V56.7799H252.089V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.961,
    cy: 44.3018,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.089 31.5723H239.484V44.1764H252.089V31.5723Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.961,
    cy: 31.6983,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip22_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.643 -6.24023H126.039V6.36393H138.643V-6.24023Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.516,
    cy: -6.11422,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.516,
    cy: -6.11424,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip23_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.44 44.1758H100.836V56.7799H113.44V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.313,
    cy: 44.3018,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.313,
    cy: 44.3018,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip24_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.065 44.1758H176.461V56.7799H189.065V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.938,
    cy: 44.3018,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.938,
    cy: 44.3018,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip25_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.643 31.5723H126.039V44.1764H138.643V31.5723Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.516,
    cy: 31.6983,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.516,
    cy: 31.6983,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip26_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.667 31.5725H189.062V44.1767H201.667V31.5725Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.54,
    cy: 31.6985,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.539,
    cy: 31.6985,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip27_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.089 6.36523H239.484V18.9694H252.089V6.36523Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.961,
    cy: 6.49125,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip28_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.042 6.36499H113.438V18.9692H126.042V6.36499Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.563,
    cy: 6.491,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.563,
    cy: 6.49098,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip29_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.065 18.9688H176.461V31.5729H189.065V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.586,
    cy: 19.0948,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.586,
    cy: 19.0947,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip30_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.479 -6.23999H226.875V6.36418H239.479V-6.23999Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.001,
    cy: -6.11398,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227,
    cy: -6.114,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip31_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4167 18.9688H37.8125V31.5729H50.4167V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.2896,
    cy: 31.4468,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.2893,
    cy: 31.4468,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip32_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.44 56.7812H100.836V69.3854H113.44V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.313,
    cy: 69.2593,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.313,
    cy: 69.2593,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip33_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.042 18.9688H113.438V31.5729H126.042V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.915,
    cy: 31.4468,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.914,
    cy: 31.4468,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip34_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2057 6.36523H12.6016V18.9694H25.2057V6.36523Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.9026,
    cy: 12.6673,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip35_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.6276 -6.24023H63.0234V6.36393H75.6276V-6.24023Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.5005,
    cy: 6.23783,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip36_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.0182 18.9688H50.4141V31.5729H63.0182V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.7151,
    cy: 31.573,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip37_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.089 56.7812H239.484V69.3854H252.089V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip38_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.0182 31.5723H50.4141V44.1764H63.0182V31.5723Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.894,
    cy: 31.6983,
    r: 12.3521,
    transform: "rotate(90 62.894 31.6983)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5385,
    cy: 44.0503,
    r: 12.3521,
    transform: "rotate(90 50.5385 44.0503)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip39_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.253 18.9688H138.648V31.5729H151.253V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.128,
    cy: 19.0948,
    r: 12.3521,
    transform: "rotate(90 151.128 19.0948)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.773,
    cy: 31.4468,
    r: 12.3521,
    transform: "rotate(90 138.773 31.4468)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip40_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.854 -6.23999H151.25V6.36418H163.854V-6.23999Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.73,
    cy: -6.11398,
    r: 12.3521,
    transform: "rotate(90 163.73 -6.11398)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.374,
    cy: 6.23807,
    r: 12.3521,
    transform: "rotate(90 151.374 6.23807)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip41_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.065 6.36523H176.461V18.9694H189.065V6.36523Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.941,
    cy: 6.49124,
    r: 12.3521,
    transform: "rotate(90 188.941 6.49124)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.585,
    cy: 18.8433,
    r: 12.3521,
    transform: "rotate(90 176.585 18.8433)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip42_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.878 -6.24023H214.273V6.36393H226.878V-6.24023Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.753,
    cy: -6.11422,
    r: 12.3521,
    transform: "rotate(90 226.753 -6.11422)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.398,
    cy: 6.23783,
    r: 12.3521,
    transform: "rotate(90 214.398 6.23783)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip43_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.268 18.9688H201.664V31.5729H214.268V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.144,
    cy: 19.0948,
    r: 12.3521,
    transform: "rotate(90 214.144 19.0948)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.789,
    cy: 31.4468,
    r: 12.3521,
    transform: "rotate(90 201.789 31.4468)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip44_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.479 18.9688H226.875V31.5729H239.479V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.355,
    cy: 19.0948,
    r: 12.3521,
    transform: "rotate(90 239.355 19.0948)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.999,
    cy: 31.4468,
    r: 12.3521,
    transform: "rotate(90 226.999 31.4468)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip45_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.042 31.5725H113.438V44.1767H126.042V31.5725Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.917,
    cy: 31.6985,
    r: 12.3521,
    transform: "rotate(90 125.917 31.6985)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.562,
    cy: 44.0506,
    r: 12.3521,
    transform: "rotate(90 113.562 44.0506)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip46_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.831 44.1758H88.2266V56.7799H100.831V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.707,
    cy: 44.3018,
    r: 12.3521,
    transform: "rotate(90 100.707 44.3018)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.351,
    cy: 56.6538,
    r: 12.3521,
    transform: "rotate(90 88.351 56.6538)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip47_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.268 56.7812H201.664V69.3854H214.268V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.144,
    cy: 56.9073,
    r: 12.3521,
    transform: "rotate(90 214.144 56.9073)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.789,
    cy: 69.2593,
    r: 12.3521,
    transform: "rotate(90 201.789 69.2593)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip48_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.6276 56.7812H63.0234V69.3854H75.6276V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.5034,
    cy: 56.9073,
    r: 12.3521,
    transform: "rotate(90 75.5034 56.9073)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1479,
    cy: 69.2593,
    r: 12.3521,
    transform: "rotate(90 63.1479 69.2593)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip49_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8151 6.36523H25.2109V18.9694H37.8151V6.36523Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.8167,
    cy: 12.6673,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip50_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.6276 31.5723H63.0234V44.1764H75.6276V31.5723Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.6292,
    cy: 37.8743,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip51_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.643 18.9688H126.039V31.5729H138.643V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.645,
    cy: 25.2708,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip52_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8151 18.9688H25.2109V31.5729H37.8151V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.512,
    cy: 31.573,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip53_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8151 31.5723H25.2109V44.1764H37.8151V31.5723Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.2112,
    cy: 37.8743,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip54_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.2292 56.7812H75.625V69.3854H88.2292V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.6253,
    cy: 63.0833,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip55_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.854 31.5725H151.25V44.1767H163.854V31.5725Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.25,
    cy: 37.8745,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip56_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.065 56.7812H176.461V69.3854H189.065V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.461,
    cy: 63.0833,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip57_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.2292 18.9688H75.625V31.5729H88.2292V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.6253,
    cy: 25.2708,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip58_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.44 -6.24023H100.836V6.36393H113.44V-6.24023Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.836,
    cy: 0.0617847,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip59_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.667 -6.23999H189.062V6.36418H201.667V-6.23999Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.063,
    cy: 0.0620289,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip60_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.268 6.36523H201.664V18.9694H214.268V6.36523Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.664,
    cy: 12.6673,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip61_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.479 6.36499H226.875V18.9692H239.479V6.36499Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.875,
    cy: 12.667,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip62_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.878 18.9688H214.273V31.5729H226.878V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.274,
    cy: 25.2708,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip63_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.042 -6.23999H113.438V6.36418H126.042V-6.23999Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.438,
    cy: 0.0620289,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip64_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.042 44.1758H113.438V56.7799H126.042V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.438,
    cy: 50.4778,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip65_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.831 -6.24023H88.2266V6.36393H100.831V-6.24023Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.832,
    cy: 0.0617847,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip66_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.253 -6.24023H138.648V6.36393H151.253V-6.24023Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.254,
    cy: 0.0617847,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip67_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.464 -6.24023H163.859V6.36393H176.464V-6.24023Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.465,
    cy: 0.0617847,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip68_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.854 6.36499H151.25V18.9692H163.854V6.36499Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.856,
    cy: 12.667,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip69_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.831 31.5723H88.2266V44.1764H100.831V31.5723Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.5276,
    cy: 31.5723,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip70_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2057 18.9688H12.6016V31.5729H25.2057V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.9026,
    cy: 18.9688,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip71_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.831 18.9688H88.2266V31.5729H100.831V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip72_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.464 18.9688H163.859V31.5729H176.464V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip73_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.2292 -6.23999H75.625V6.36418H88.2292V-6.23999Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip74_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.44 31.5723H100.836V44.1764H113.44V31.5723Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip75_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.2292 31.5725H75.625V44.1767H88.2292V31.5725Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.7505,
    cy: 31.6985,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.1021,
    cy: 44.0506,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip76_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4167 56.7812H37.8125V69.3854H50.4167V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.938,
    cy: 56.9073,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.2896,
    cy: 69.2593,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip77_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8151 44.1758H25.2109V56.7799H37.8151V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.3365,
    cy: 44.3018,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.688,
    cy: 56.6538,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip78_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.253 44.1758H138.648V56.7799H151.253V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.774,
    cy: 44.3018,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.126,
    cy: 56.6538,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip79_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.464 56.7812H163.859V69.3854H176.464V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.985,
    cy: 56.9073,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.336,
    cy: 69.2593,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip80_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4167 31.5725H37.8125V44.1767H50.4167V31.5725Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.938,
    cy: 44.0506,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip81_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.253 31.5723H138.648V44.1764H151.253V31.5723Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.774,
    cy: 44.0503,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip82_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.831 6.36523H88.2266V18.9694H100.831V6.36523Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.3521,
    cy: 6.49125,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.3518,
    cy: 6.49123,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip83_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.854 44.1758H151.25V56.7799H163.854V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.376,
    cy: 44.3018,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.375,
    cy: 44.3018,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip84_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.479 56.7812H226.875V69.3854H239.479V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.001,
    cy: 56.9073,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227,
    cy: 56.9072,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip85_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6042 6.36499H0V18.9692H12.6042V6.36499Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.4771,
    cy: 18.8431,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.4768,
    cy: 18.843,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip86_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4167 44.1758H37.8125V56.7799H50.4167V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.938,
    cy: 44.3018,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.9378,
    cy: 44.3018,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip87_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2057 31.5723H12.6016V44.1764H25.2057V31.5723Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.7271,
    cy: 31.6983,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip88_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.0182 44.1758H50.4141V56.7799H63.0182V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.8911,
    cy: 44.3018,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip89_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.6276 44.1758H63.0234V56.7799H75.6276V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.149,
    cy: 44.3018,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1487,
    cy: 44.3018,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip90_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.253 6.36523H138.648V18.9694H151.253V6.36523Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.774,
    cy: 6.49125,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.774,
    cy: 6.49123,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip91_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.464 6.36523H163.859V18.9694H176.464V6.36523Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.985,
    cy: 6.49125,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.985,
    cy: 6.49123,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip92_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2057 44.1758H12.6016V56.7799H25.2057V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.7271,
    cy: 44.3018,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.7268,
    cy: 44.3018,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip93_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2057 56.7812H12.6016V69.3854H25.2057V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.0786,
    cy: 56.9073,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip94_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.831 56.7812H88.2266V69.3854H100.831V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.704,
    cy: 56.9073,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip95_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.878 44.1758H214.273V56.7799H226.878V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.751,
    cy: 44.3018,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip96_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6042 31.5725H0V44.1767H12.6042V31.5725Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.4771,
    cy: 44.0506,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip97_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6042 44.1758H0V56.7799H12.6042V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.4771,
    cy: 44.3018,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip98_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6042 18.9688H0V31.5729H12.6042V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.30104,
    cy: 25.2708,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip99_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8151 56.7812H25.2109V69.3854H37.8151V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.688,
    cy: 69.2593,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip100_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.643 44.1758H126.039V56.7799H138.643V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.516,
    cy: 56.6538,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip101_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.464 44.1758H163.859V56.7799H176.464V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.336,
    cy: 56.6538,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip102_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.2292 44.1758H75.625V56.7799H88.2292V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.1021,
    cy: 56.6538,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip103_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.0182 56.7812H50.4141V69.3854H63.0182V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.8911,
    cy: 69.2593,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip104_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6042 56.7812H0V69.3854H12.6042V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.30104,
    cy: 63.0833,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip105_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.854 56.7812H151.25V69.3854H163.854V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.551,
    cy: 63.0833,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip106_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.878 56.7812H214.273V69.3854H226.878V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.574,
    cy: 63.0833,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip107_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.878 6.36523H214.273V18.9694H226.878V6.36523Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.574,
    cy: 12.6673,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip108_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.268 -6.24023H201.664V6.36393H214.268V-6.24023Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.965,
    cy: 0.0617847,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip109_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.667 18.9688H189.062V31.5729H201.667V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.364,
    cy: 25.2708,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip110_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.065 -6.24023H176.461V6.36393H189.065V-6.24023Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182.762,
    cy: 0.0617847,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip111_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.253 56.7812H138.648V69.3854H151.253V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.774,
    cy: 69.2593,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip112_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.479 44.1758H226.875V56.7799H239.479V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.001,
    cy: 56.6538,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip113_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.065 31.5723H176.461V44.1764H189.065V31.5723Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.586,
    cy: 44.0503,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip114_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.089 -6.24023H239.484V6.36393H252.089V-6.24023Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.61,
    cy: 6.23783,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip115_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.268 31.5723H201.664V44.1764H214.268V31.5723Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.79,
    cy: 44.0503,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip116_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.667 6.36499H189.062V18.9692H201.667V6.36499Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.188,
    cy: 18.8431,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip117_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.667 56.7812H189.062V69.3854H201.667V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.188,
    cy: 69.2593,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip118_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.479 31.5725H226.875V44.1767H239.479V31.5725Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.001,
    cy: 44.0506,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip119_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.854 18.9688H151.25V31.5729H163.854V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.376,
    cy: 31.4468,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip120_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.667 44.1758H189.062V56.7799H201.667V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.364,
    cy: 50.4778,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip121_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.089 18.9688H239.484V31.5729H252.089V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.785,
    cy: 25.2708,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip122_3967_65956)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip123_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.206 -6.24023H251.602V6.36393H264.206V-6.24023Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.082,
    cy: -6.11422,
    r: 12.3521,
    transform: "rotate(90 264.082 -6.11422)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.726,
    cy: 6.23783,
    r: 12.3521,
    transform: "rotate(90 251.726 6.23783)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip124_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.417 6.36499H276.812V18.9692H289.417V6.36499Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.292,
    cy: 6.491,
    r: 12.3521,
    transform: "rotate(90 289.292 6.491)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.937,
    cy: 18.8431,
    r: 12.3521,
    transform: "rotate(90 276.937 18.8431)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip125_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.018 -6.24023H289.414V6.36393H302.018V-6.24023Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.54,
    cy: -6.11422,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.891,
    cy: 6.23783,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip126_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.44 18.9688H339.836V31.5729H352.44V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.961,
    cy: 19.0948,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.313,
    cy: 31.4468,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip127_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.229 6.36499H314.625V18.9692H327.229V6.36499Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.751,
    cy: 6.491,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 327.102,
    cy: 18.8431,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip128_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.604 -6.23999H239V6.36418H251.604V-6.23999Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.301,
    cy: -6.23997,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip129_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.815 -6.24023H264.211V6.36393H276.815V-6.24023Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.211,
    cy: 0.0617847,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip130_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.417 -6.23999H276.812V6.36418H289.417V-6.23999Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.114,
    cy: 0.0620289,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip131_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.44 6.36523H339.836V18.9694H352.44V6.36523Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346.137,
    cy: 12.6673,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip132_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.628 6.36523H302.023V18.9694H314.628V6.36523Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.324,
    cy: 12.6673,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip133_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.018 6.36523H289.414V18.9694H302.018V6.36523Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.54,
    cy: 6.49125,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip134_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.628 18.9688H302.023V31.5729H314.628V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.501,
    cy: 19.0948,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.5,
    cy: 19.0947,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip135_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.44 44.1758H339.836V56.7799H352.44V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.313,
    cy: 44.3018,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip136_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.417 18.9688H276.812V31.5729H289.417V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.29,
    cy: 31.4468,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.289,
    cy: 31.4468,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip137_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.44 56.7812H339.836V69.3854H352.44V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.313,
    cy: 69.2593,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip138_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.206 6.36523H251.602V18.9694H264.206V6.36523Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.903,
    cy: 12.6673,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip139_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.628 -6.24023H302.023V6.36393H314.628V-6.24023Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.501,
    cy: 6.23783,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip140_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.018 18.9688H289.414V31.5729H302.018V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 295.715,
    cy: 31.573,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip141_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.018 31.5723H289.414V44.1764H302.018V31.5723Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.894,
    cy: 31.6983,
    r: 12.3521,
    transform: "rotate(90 301.894 31.6983)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.539,
    cy: 44.0503,
    r: 12.3521,
    transform: "rotate(90 289.539 44.0503)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip142_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.831 44.1758H327.227V56.7799H339.831V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.707,
    cy: 44.3018,
    r: 12.3521,
    transform: "rotate(90 339.707 44.3018)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 327.351,
    cy: 56.6538,
    r: 12.3521,
    transform: "rotate(90 327.351 56.6538)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip143_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.628 56.7812H302.023V69.3854H314.628V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.503,
    cy: 56.9073,
    r: 12.3521,
    transform: "rotate(90 314.503 56.9073)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.148,
    cy: 69.2593,
    r: 12.3521,
    transform: "rotate(90 302.148 69.2593)",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip144_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.815 6.36523H264.211V18.9694H276.815V6.36523Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.817,
    cy: 12.6673,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip145_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.628 31.5723H302.023V44.1764H314.628V31.5723Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.629,
    cy: 37.8743,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip146_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.815 18.9688H264.211V31.5729H276.815V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.512,
    cy: 31.573,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip147_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.815 31.5723H264.211V44.1764H276.815V31.5723Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.211,
    cy: 37.8743,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip148_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.229 56.7812H314.625V69.3854H327.229V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.625,
    cy: 63.0833,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip149_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.229 18.9688H314.625V31.5729H327.229V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.625,
    cy: 25.2708,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip150_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.44 -6.24023H339.836V6.36393H352.44V-6.24023Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.836,
    cy: 0.0617847,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip151_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.831 -6.24023H327.227V6.36393H339.831V-6.24023Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.832,
    cy: 0.0617847,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip152_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.831 31.5723H327.227V44.1764H339.831V31.5723Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.528,
    cy: 31.5723,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip153_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.206 18.9688H251.602V31.5729H264.206V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.903,
    cy: 18.9688,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip154_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.831 18.9688H327.227V31.5729H339.831V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip155_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.229 -6.23999H314.625V6.36418H327.229V-6.23999Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip156_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.44 31.5723H339.836V44.1764H352.44V31.5723Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip157_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.229 31.5725H314.625V44.1767H327.229V31.5725Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.751,
    cy: 31.6985,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 327.102,
    cy: 44.0506,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip158_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.417 56.7812H276.812V69.3854H289.417V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.938,
    cy: 56.9073,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.29,
    cy: 69.2593,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip159_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.815 44.1758H264.211V56.7799H276.815V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.336,
    cy: 44.3018,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.688,
    cy: 56.6538,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip160_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.417 31.5725H276.812V44.1767H289.417V31.5725Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.938,
    cy: 44.0506,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip161_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.831 6.36523H327.227V18.9694H339.831V6.36523Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 327.352,
    cy: 6.49125,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 327.352,
    cy: 6.49123,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip162_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.604 6.36499H239V18.9692H251.604V6.36499Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.477,
    cy: 18.8431,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.477,
    cy: 18.843,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip163_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.417 44.1758H276.812V56.7799H289.417V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.938,
    cy: 44.3018,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.938,
    cy: 44.3018,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip164_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.206 31.5723H251.602V44.1764H264.206V31.5723Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.727,
    cy: 31.6983,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip165_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.018 44.1758H289.414V56.7799H302.018V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.891,
    cy: 44.3018,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip166_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.628 44.1758H302.023V56.7799H314.628V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.149,
    cy: 44.3018,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.149,
    cy: 44.3018,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip167_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.206 44.1758H251.602V56.7799H264.206V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.727,
    cy: 44.3018,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.727,
    cy: 44.3018,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip168_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.206 56.7812H251.602V69.3854H264.206V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.079,
    cy: 56.9073,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip169_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.831 56.7812H327.227V69.3854H339.831V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.704,
    cy: 56.9073,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip170_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.604 31.5725H239V44.1767H251.604V31.5725Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.477,
    cy: 44.0506,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip171_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.604 44.1758H239V56.7799H251.604V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.477,
    cy: 44.3018,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip172_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.604 18.9688H239V31.5729H251.604V18.9688Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.301,
    cy: 25.2708,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip173_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.815 56.7812H264.211V69.3854H276.815V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.688,
    cy: 69.2593,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip174_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.229 44.1758H314.625V56.7799H327.229V44.1758Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 327.102,
    cy: 56.6538,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip175_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.018 56.7812H289.414V69.3854H302.018V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.891,
    cy: 69.2593,
    r: 12.3521,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip176_3967_65956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.604 56.7812H239V69.3854H251.604V56.7812Z",
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.301,
    cy: 63.0833,
    r: 6.17604,
    stroke: "#719B9E",
    strokeOpacity: 0.36,
    strokeWidth: 0.252083
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 63,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 242,
    height: 136.125,
    fill: "white",
    transform: "translate(0 -18.8438)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(12.6016 -6.24023)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(37.8125 6.36499)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(113.438 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(50.4141 -6.24023)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(100.836 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(126.039 6.36523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(75.625 6.36499)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(0 -6.23999)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(126.039 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(25.2109 -6.24023)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(37.8125 -6.23999)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(100.836 6.36523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(63.0234 6.36523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(50.4141 6.36523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(63.0234 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(163.859 31.5723)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(214.273 31.5723)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(201.664 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(239.484 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(239.484 31.5723)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(126.039 -6.24023)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(100.836 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(176.461 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(126.039 31.5723)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(189.062 31.5725)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(239.484 6.36523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip28_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(113.438 6.36499)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip29_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(176.461 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip30_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(226.875 -6.23999)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip31_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(37.8125 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip32_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(100.836 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip33_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(113.438 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip34_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(12.6016 6.36523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip35_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(63.0234 -6.24023)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip36_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(50.4141 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip37_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(239.484 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip38_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(50.4141 31.5723)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip39_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(138.648 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip40_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(151.25 -6.23999)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip41_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(176.461 6.36523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip42_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(214.273 -6.24023)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip43_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(201.664 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip44_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(226.875 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip45_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(113.438 31.5725)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip46_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(88.2266 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip47_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(201.664 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip48_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(63.0234 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip49_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(25.2109 6.36523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip50_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(63.0234 31.5723)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip51_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(126.039 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip52_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(25.2109 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip53_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(25.2109 31.5723)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip54_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(75.625 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip55_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(151.25 31.5725)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip56_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(176.461 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip57_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(75.625 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip58_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(100.836 -6.24023)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip59_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(189.062 -6.23999)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip60_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(201.664 6.36523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip61_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(226.875 6.36499)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip62_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(214.273 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip63_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(113.438 -6.23999)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip64_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(113.438 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip65_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(88.2266 -6.24023)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip66_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(138.648 -6.24023)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip67_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(163.859 -6.24023)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip68_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(151.25 6.36499)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip69_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(88.2266 31.5723)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip70_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(12.6016 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip71_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(88.2266 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip72_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(163.859 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip73_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(75.625 -6.23999)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip74_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(100.836 31.5723)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip75_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(75.625 31.5725)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip76_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(37.8125 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip77_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(25.2109 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip78_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(138.648 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip79_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(163.859 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip80_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(37.8125 31.5725)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip81_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(138.648 31.5723)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip82_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(88.2266 6.36523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip83_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(151.25 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip84_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(226.875 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip85_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(0 6.36499)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip86_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(37.8125 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip87_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(12.6016 31.5723)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip88_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(50.4141 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip89_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(63.0234 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip90_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(138.648 6.36523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip91_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(163.859 6.36523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip92_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(12.6016 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip93_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(12.6016 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip94_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(88.2266 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip95_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(214.273 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip96_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(0 31.5725)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip97_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(0 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip98_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(0 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip99_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(25.2109 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip100_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(126.039 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip101_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(163.859 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip102_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(75.625 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip103_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(50.4141 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip104_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(0 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip105_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(151.25 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip106_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(214.273 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip107_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(214.273 6.36523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip108_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(201.664 -6.24023)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip109_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(189.062 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip110_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(176.461 -6.24023)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip111_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(138.648 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip112_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(226.875 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip113_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(176.461 31.5723)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip114_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(239.484 -6.24023)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip115_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(201.664 31.5723)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip116_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(189.062 6.36499)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip117_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(189.062 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip118_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(226.875 31.5725)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip119_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(151.25 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip120_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(189.062 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip121_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(239.484 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip122_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 242,
    height: 136.125,
    fill: "white",
    transform: "translate(239 -18.8438)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip123_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(251.602 -6.24023)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip124_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(276.812 6.36499)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip125_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(289.414 -6.24023)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip126_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(339.836 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip127_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(314.625 6.36499)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip128_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(239 -6.23999)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip129_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(264.211 -6.24023)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip130_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(276.812 -6.23999)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip131_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(339.836 6.36523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip132_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(302.023 6.36523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip133_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(289.414 6.36523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip134_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(302.023 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip135_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(339.836 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip136_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(276.812 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip137_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(339.836 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip138_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(251.602 6.36523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip139_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(302.023 -6.24023)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip140_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(289.414 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip141_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(289.414 31.5723)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip142_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(327.227 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip143_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(302.023 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip144_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(264.211 6.36523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip145_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(302.023 31.5723)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip146_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(264.211 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip147_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(264.211 31.5723)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip148_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(314.625 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip149_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(314.625 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip150_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(339.836 -6.24023)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip151_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(327.227 -6.24023)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip152_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(327.227 31.5723)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip153_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(251.602 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip154_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(327.227 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip155_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(314.625 -6.23999)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip156_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(339.836 31.5723)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip157_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(314.625 31.5725)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip158_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(276.812 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip159_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(264.211 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip160_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(276.812 31.5725)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip161_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(327.227 6.36523)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip162_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(239 6.36499)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip163_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(276.812 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip164_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(251.602 31.5723)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip165_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(289.414 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip166_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(302.023 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip167_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(251.602 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip168_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(251.602 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip169_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(327.227 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip170_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(239 31.5725)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip171_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(239 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip172_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(239 18.9688)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip173_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(264.211 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip174_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(314.625 44.1758)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip175_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(289.414 56.7812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip176_3967_65956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6042,
    height: 12.6042,
    fill: "white",
    transform: "translate(239 56.7812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamecard);
export default __webpack_public_path__ + "static/media/Namecard.a8c596253af912531b8d5076e49fab4c.svg";
export { ForwardRef as ReactComponent };